import styled, { css } from 'styled-components';

import { SideBox } from 'Modules/HeroBanner/OpenDays/Event/Event.styled';

export const StyledSideBox = styled(SideBox)<{ $isWhiteBackground?: boolean }>`
    ${({ theme, $isWhiteBackground }) => css`
        color: ${theme.colors.secondaryContrast.hex};
        margin: 1rem 0;
        padding: 1rem;
        max-width: 25rem;

        ${$isWhiteBackground &&
        css`
            background: ${theme.colors.tertiary.hex};
            color: ${theme.colors.primaryContrast.hex};
        `}

        @media ${theme.breakpoints.large.media} {
            margin: 0;
            max-width: none;
        }
    `}
`;

export const SideBoxText = styled.p`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1.125rem;
        font-weight: 700;
        line-height: 1.65;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const SideBoxDate = styled.p`
    ${({ theme }) => css`
        margin: 0.5rem 0 1rem;
        font-size: 2rem;
        font-weight: 700;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.25rem;
        }
    `}
`;
